module.exports = __webpack_public_path__ + "img/es-es-logo.7982c9d.svg";